////////////////////////////////////////////////////////////
//  Program: Inspection Form.jsx                          //
//  Application:  Inspection  Form                        //
//  Option: List of Template                              //
//  Developer: kiran singh                                //
//  Date: 2022-04-08                                      //
////////////////////////////////////////////////////////////
import React, { Component } from "react";
import SimpleReactValidator from "simple-react-validator";
import { Button, Table, Modal } from "react-bootstrap";
import InspectionService from "../../services/InspectionService";
// import Moment from "moment";
import { Link } from "react-router-dom";
import exportIcon from "./../../assets/images/export-icon.svg";
// import blacktick from "./../../assets/images/black-tick.svg";
import greentick from "./../../assets/images/green-tick.svg";
// import renderHTML from 'react-render-html';
import redtick from "./../../assets/images/red-tick.svg";
import bluetick from "./../../assets/images/blue-tick.svg";
import brownArrow from "./../../assets/images/brown-arrow.svg";
import moment from "moment-timezone";
import DeleteImageModal from "../DeleteImageModal";
import ActionItemService from "../../services/ActionItemService";
import ReactImageMagnify from "react-image-magnify";
import RiskAssessment  from "../common/RiskAssessment";

export class InspectionForm extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.state = {
      showBasicModal: false,
      slug: this.props.match.params.slug,
      submission: [],
      mro: [],
      answer: global.mroAnswer,
      isSubmit: false,
      loading: false,
      deleteInspModal: false,
      showModalImage: false,
      openCollapsibles: [],
      modalTaskName: "",
      modalItems: [],
      role_id: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).role_id : null
    };
    this.closeModal = this.closeModal.bind(this);
    this.insPdfGenerator = this.insPdfGenerator.bind(this);
    this.opendeleteInspectionModal = this.opendeleteInspectionModal.bind(this);
    this.onCloseImagePop = this.onCloseImagePop.bind(this);
  }
  opendeleteInspectionModal(slug) {
    this.setState({ deleteInspModal: true });
  }
  closedeleteInspModal() {
    this.setState({ deleteInspModal: false });
  }
  async insPdfGenerator(queryString = "") {
    this.setState({ loading: true });
    var list = [];
    let res = await InspectionService.getInspectionPdfBySlug(this.state.slug);
    if (global.successStatus.includes(res.status)) {
      list = res.data.report["0"] ? res.data.report["0"] : [];
    }
    this.setState({ list: list });
    this.setState({ loading: false });
    window.open(this.state.list.filePath, "_blank");
  }
  closeModal() {
    this.setState({ showBasicModal: false });
  }
  async componentDidMount() {
    this.getInspection();
  }

  async getInspection() {
    this.setState({ loading: true });
    if (this.state.slug !== undefined) {
      var resData = {};
      let res = await InspectionService.getInspectionBySlug(this.state.slug);
      if (global.successStatus.includes(res.status)) {
        resData = res.data.data ? res.data.data : {};
        resData.inspection_no = resData.inspection_no
          ? resData.inspection_no
          : "";
        resData.zone_type_id = resData ? resData.zone_type.zone_type_id : "";
        resData.zone_type = resData.zone_type
          ? resData.zone_type.zone_name
          : "";
        resData.checklist_slug = resData.checklist
          ? resData.checklist.slug
          : "";
        resData.description = resData.checklist
          ? resData.checklist.description
          : "";
        resData.checklist = resData.checklist
          ? resData.checklist.checklist_name
          : "";
        resData.property_slug = resData.property ? resData.property.slug : "";
        resData.property_name = resData.property
          ? resData.property.property_name
          : "";
        resData.technician = resData.inspector
          ? resData.inspector.full_name
          : "";
        resData.room = resData.room ? resData.room.room_name : "";
        resData.commercial = resData.commercial
          ? resData.commercial.commercials_zone_name
          : "";
        resData.zone = resData.zone ? resData.zone.equipment_zone_name : "";
        resData.submission = resData.submission ? resData.submission : "";
        resData.category = resData.category ? resData.category : "";
        resData.mro = resData.mro ? resData.mro : "";
        resData.status_id = resData.status_id == 1 ? true : false;
        resData.timezone = resData?.property
          ? resData?.property?.timezone?.timezone_name
          : "";
        resData.weight_score = resData.weight_score ?? 0;
        resData.actual_score = resData.actual_score ?? 0;
        resData.possible_score = resData.possible_score ?? 0;
        resData.risk_level_config = resData.risk_level_config ?? [];

        if (resData.inspection_type === 2 && Array.isArray(resData.reviewer_data)) {
          resData.reviewer_data = resData.reviewer_data.map((item) => {
            const info = typeof item.user_info === "string" ? JSON.parse(item.user_info) : item.user_info;
            return { ...item, user_info: info };
          });
        }

        // Normalize each task's notes/MROs (0..n entries). The API splits them into
        // two separate arrays: task.mros (full MRO tickets, is_mro: 1) and task.notes
        // (plain notes, is_mro: 2) - combine both into one list per task for display.
        if (Array.isArray(resData.category)) {
          resData.category = resData.category.map((cat) => ({
            ...cat,
            tasks: Array.isArray(cat.tasks)
              ? cat.tasks.map((task) => {
                  const rawItems = [
                    ...(Array.isArray(task.mros) ? task.mros : []),
                    ...(Array.isArray(task.notes) ? task.notes : []),
                  ];
                  const items = rawItems.map((item) => ({
                    slug: item.note_with_mro_slug || item.slug || null,
                    note: item.note ?? null,
                    title: item.title ?? null,
                    is_mro: item.is_mro === 1 ? 1 : 0,
                    mro_number: item.mro_number ?? null,
                    images: Array.isArray(item.images) ? item.images : [],
                  }));
                  return {
                    ...task,
                    notesMrosItems: items,
                    notes_mros_count: {
                      total: items.length,
                      mros: items.filter((m) => m.is_mro === 1).length,
                      notes: items.filter((m) => m.is_mro !== 1).length,
                    },
                  };
                })
              : [],
          }));
        }

        this.setState(resData);
        this.setState({
          // time_out: Moment(resData.out_time).format("DD MMM, YY - hh:mm A"),
          time_out: resData.out_time
            ? moment(resData.out_time).format("DD MMM, YY - hh:mm A")
            : "",
        });
        this.setState({
          // time_in: Moment(resData.in_time).format("DD MMM, YY - hh:mm A"),
          time_in: moment(resData.in_time).format("DD MMM, YY - hh:mm A"),
          openCollapsibles: Array(resData.category?.length || 0).fill(true),
        });
      }
      this.setState({ loading: false });
      var isAvailConst = 0;
      if (this.state.category) {
        this.state.category.map((cat, j) => {
          if (cat.tasks) {
            cat.tasks.map((tsk, i) => {
              if (tsk.notes_mros_count?.mros > 0) {
                isAvailConst = 1;
              }
            });
          }
        });
      }
      this.setState({ isAvail: isAvailConst });
    }
  }
  // delete insp

  async deleteInsp(slug) {
    this.setState({ loading: true, isDelete: true });
    let res = await InspectionService.deleteInspection(slug);
    if (global.successStatus.includes(res.status)) {
      this.closedeleteInspModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
      });
      setTimeout(
        () => this.props.history.push("/inspections"),
        global.redirect_time
      );
    } else {
      this.closedeleteInspModal();
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ loading: false, isDelete: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }

  // Delete MRO Image Start
  async deleteImage(slug) {
    this.setState({ loading: true, isSubmit: true });
    let res = await ActionItemService.deleteImage(slug);
    if (global.successStatus.includes(res.status)) {
      this.setState((prevState) => ({
        showAlertModal: true,
        alertModalType: "success",
        alertModalTitle: "Success",
        alertModalMessage: res.message ? res.message : "Success",
        showModalImage: false,
        classRemove: false,
        mroImages: prevState.mroImages.filter((image) => image.slug !== slug), // Remove the deleted image
      }));
      this.getInspection();
    } else {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
        alertModalMessage: res.data.errorMessage
          ? res.data.errorMessage
          : res.data.message,
      });
    }
    this.setState({ loading: false, isSubmit: false });
    setTimeout(
      () => this.setState({ showAlertModal: false }),
      global.alert_close_time
    );
  }
  // Delete MRO Image End
  imageRedirect(path) {
    window.open(`${path}`);
  }
  modifyTaskName(taskName) {
    // Create a temporary element to manipulate the HTML string
    const tempElement = document.createElement("div");
    tempElement.innerHTML = taskName;

    // Find all links in the element
    const links = tempElement.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
    });

    // Return the modified HTML
    return tempElement.innerHTML;
  }
  /* Opens the read-only Notes list for one task - a task can have several notes
     now, so this always shows the full list rather than a single note. */
  openNotesModal(task) {
    const items = Array.isArray(task.notesMrosItems) ? task.notesMrosItems : [];
    this.setState({
      showBasicModal: true,
      modalType: "note",
      modalTaskName: task.task_name,
      modalItems: items.filter((item) => item.is_mro !== 1),
    });
  }
  /* Opens the read-only MROs list for one task - a task can have several MROs
     now, so this always shows the full list rather than a single MRO. */
  openMrosModal(task) {
    const items = Array.isArray(task.notesMrosItems) ? task.notesMrosItems : [];
    this.setState({
      showBasicModal: true,
      modalType: "mro",
      modalTaskName: task.task_name,
      modalItems: items.filter((item) => item.is_mro === 1),
    });
  }
  toggleModal(slug) {
    // this.setState({ showModalImage: !this.state.showModalImage, imageSlug:slug });
    this.setState({
      showModalImage: true,
      imageSlug: slug,
      classRemove: true,
    });
  }
  handleToggle = (index) => {
    const { openCollapsibles } = this.state;
    openCollapsibles[index] = !openCollapsibles[index]; // Toggle the state
    this.setState({ openCollapsibles });
  };
  onCloseImagePop() {
    this.setState({ showModalImage: false, classRemove: false });
  }
  openInspectionUpdate() {
    localStorage.removeItem("auditCategory");
    localStorage.setItem(
      "propertyNameInspectionPerform",
      this.state.property_name
    );
    localStorage.setItem(
      "inspection_name_inspection_resume",
      this.state.checklist
    );
    localStorage.setItem(
      "description_inspection_resume",
      this.state.description ? this.state.description : ""
    );
    this.props.history.push({
      pathname: `/inspection-perform/${this.state.property_slug}/${this.state.zone_type_id}/${this.state.checklist_slug}`,
      state: {
        isResume: true,
        inspectionSlug: this.state.slug,
      },
    });
  }
  async openInspectionReopen() {
    // Call API to update inspection status to 1 (reopen)
    this.setState({ loading: true });
    try {
      let inputData = {
        status_id: 1,
      };
      const res = await InspectionService.InspectionReopenUpdate(this.state.slug, inputData);
      if (global.successStatus.includes(res.status)) {
        // After successful status update, proceed as before
        localStorage.removeItem("auditCategory");
        localStorage.setItem(
          "propertyNameInspectionPerform",
          this.state.property_name
        );
        localStorage.setItem(
          "inspection_name_inspection_resume",
          this.state.checklist
        );
        localStorage.setItem(
          "description_inspection_resume",
          this.state.description ? this.state.description : ""
        );
        this.props.history.push({
          pathname: `/inspection-perform/${this.state.property_slug}/${this.state.zone_type_id}/${this.state.checklist_slug}`,
          state: {
            isResume: true,
            inspectionSlug: this.state.slug,
          },
        });
      } else {
        this.setState({
          showAlertModal: true,
          alertModalType: "error",
          alertModalTitle: res.data.errorCode ? res.data.errorCode : "Error!",
          alertModalMessage: res.data.errorMessage
            ? res.data.errorMessage
            : res.data.message,
        });
      }
    } catch (error) {
      this.setState({
        showAlertModal: true,
        alertModalType: "error",
        alertModalTitle: "Error!",
        alertModalMessage: error.message || "Failed to reopen inspection.",
      });
    }
    this.setState({ loading: false });
  }
  render() {
    const additionalClass = this.state.classRemove ? "d-none" : "";
    return (
      <div>
        <main>
          <div className="container-fluid">
            <div className="row row-xs">
              <div className="col-md-12">
                <div className="dashbaord-pageHeadertitle ">
                  <h3 className="flex-column">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <h3>Inspections</h3>
                      <div className="btnNavigate d-flex justify-content-end">
                        {/* {global.use</h3>rPermissions.checkPermission(
                            "inspection-resume"
                          ) && */}
                        {this.state.inspection_status === 1 &&
                          global.userPermissions.checkPermission("inspection-resume") && (
                          <Button
                            type="button"
                            onClick={() => {
                            this.openInspectionUpdate(this.state.slug);
                            }}
                            className="gf-primary-btn-small-one  mg-l-7 mg-r-7 loader_btn"
                          >
                            Resume
                          </Button>
                          )}
                        {/* Reopen Button: status 2, admin, and permission */}
                        {this.state.inspection_status === 2 &&
                          global.userPermissions.checkPermission("inspection-reopen") && (
                          <Button
                            type="button"
                            onClick={() => {
                            this.openInspectionReopen(this.state.slug);
                            }}
                            className="gf-primary-btn-small-one  mg-l-7 mg-r-7 loader_btn"
                          >
                            Reopen
                          </Button>
                          )}
                            {global.userPermissions.checkPermission(
                              "inspection-delete"
                            ) && (
                              <Button
                              type="button"
                              onClick={() => {
                              this.opendeleteInspectionModal(this.state.slug);
                            }}
                            className="gf-primary-btn-small-one  mg-l-7 mg-r-7 loader_btn delete-inspection-btn"
                          >
                            Delete Inspection
                          </Button>
                        )}
                        {global.userPermissions.checkPermission(
                          "inspection-list"
                        ) && (
                          <Button
                            onClick={this.insPdfGenerator}
                            className="gf-primary-btn-small-one loader_btn pdf_gen export_pdf_btn"
                          >
                            <img src={exportIcon} alt="" />
                            {this.state.loading ? global.loader : "Export PDF"}
                          </Button>
                        )}
                      </div>
                    </div>
                    <span>Inspection Detail</span>
                  </h3>
                </div>
              </div>
            </div>
            {/* for inspection info */}
            <div className="row row-xs">
              <div className="col-md-12 mg-t-0 mg-b-10 pd-t-0 pd-b-10 inspe_hgt">
                <div className="brandList dashboardRightcard d-flex flex-wrap align-items-center">
                  <div className="form-group col-md-3 m-0">
                    <label className="form-label text-left ">
                      Inspection No.
                    </label>
                    <p>#{this.state.inspection_no}</p>
                  </div>
                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">In Time</label>
                    <p>{this.state.time_in}</p>
                  </div>
                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Out Time</label>
                    <p>{this.state.time_out ? this.state.time_out : ""}</p>
                  </div>

                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Zone Type</label>
                    <p>{this.state.zone_type}</p>
                  </div>
                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Location</label>
                    <p className="m-0">
                      {this.state.location_name ? this.state.location_name : ""}
                    </p>
                  </div>
                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Created By</label>
                    <p className="m-0">{this.state.technician}</p>
                  </div>
                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Checklist</label>
                    <p className="m-0">{this.state.checklist}</p>
                  </div>

                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Property</label>
                    <p className="m-0">{this.state.property_name}</p>
                  </div>
                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Timezone</label>
                    <p className="m-0">{this.state.timezone}</p>
                  </div>
                  <div className="form-group col-md-3 m-0 inspe_hgt">
                    <label className="form-label text-left">Inspection Status</label>
                    <p className="m-0">{this.state.inspection_status_name}</p>
                  </div>
                  {this.state.is_enable_weight != 1 && (
                    <div className="form-group col-md-3 m-0 inspe_hgt">
                      <label className="form-label text-left"> Overall Progress</label>
                      <p className="m-0">
                        {this.state.inspection_percentage !== undefined && this.state.inspection_percentage !== null && this.state.inspection_percentage !== ""
                          ? `${this.state.inspection_percentage}%`
                          : ""}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/* for task */}
            {this.state.is_enable_weight == 1 && (
              <RiskAssessment 
                possible_score={this.state.possible_score} 
                actual_score={this.state.actual_score} 
                weight_score={this.state.weight_score} 
                config_data={this.state.risk_level_config}
              />

            )}

            <div className="row row-xs">
              <div className="col-md-12 mg-t-0 mg-b-10 pd-t-10 pd-b-10">
                <div className="brandSection">
                  <div className="mg-t-0 brandList dashboardRightcard pt-2 pb-2 scroll_mro">
                    <div className="table-responsive tableFormatesimple">
                      <Table bordered className="mg-b-0">
                        <thead>
                          <tr>
                            <th>TASK</th>
                            <th>YES</th>
                            <th>NO</th>
                            <th className="az-inspection-blue">NOTES</th>
                            {this.state.is_enable_weight == 1 ? 
                            <th> Score </th>
                            : ''}
                            <th className="az-inspection-red">MRO</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.category
                            ? this.state.category.map((element, index) => (
                                <React.Fragment key={index}>
                                  {/* Category Row (Trigger for Collapsible) */}
                                  <tr
                                    onClick={() => this.handleToggle(index)} // Toggle collapsible state
                                    style={{ cursor: "pointer" }} // Add pointer cursor for better UX
                                  >
                                    <th
                                     colSpan={this.state.is_enable_weight == 1 ? 6 : 5}
                                      className="p-0 border-bottom-0"
                                    >
                                      <caption className="table-accord-caption">
                                        {element.category_name
                                          ? element.category_name + ' '
                                          : ""}
                                           {this.state.is_enable_weight == 1
                                              ? (
                                                  // Show percentage first, then actual/possible scores
                                                  `${element.category_score != null ? element.category_score : 0}% ` +
                                                  ((element.total_actual_score == null && element.total_possible_score == null)
                                                    ? "(0/0)"
                                                    : `(${element.total_actual_score != null ? element.total_actual_score : 0}/${element.total_possible_score != null ? element.total_possible_score : 0})`
                                                  )
                                                )
                                              : ""}
                                        {/* Arrow Icon to Indicate Open/Closed State */}
                                        <span className="Collapsible-arrow">
                                        {element.inspection_cate_percentage !==
                                          undefined &&
                                        element.inspection_cate_percentage !==
                                          null &&
                                        element.inspection_cate_percentage !== ""
                                          ? `${element.inspection_cate_percentage}% (${element.inspection_cate_task_pass}/${element.inspection_cate_task_total})`
                                          : "0%(0/0)"}
                                          <i
                                            className={`fa ${
                                              this.state.openCollapsibles[index]
                                                ? "fa-angle-up ml-2"
                                                : "fa-angle-down ml-2"
                                            }`}
                                          ></i>
                                        </span>
                                      </caption>
                                    </th>
                                  </tr>

                                  {/* Collapsible Content (Tasks) */}
                                  {this.state.openCollapsibles[index] && (
                                    <>
                                      {element.tasks
                                        ? element.tasks.map((el, taskIndex) => {
                                            // Determine actual score: use actual_score if present, else use weight_score
                                            const actualScore =
                                              el.actual_score !== undefined && el.actual_score !== null
                                                ? el.actual_score
                                                : 0;

                                            // Determine possible score: use possible_score if present, else use weight_score
                                            const possibleScore =
                                              el.possible_score !== undefined && el.possible_score !== null
                                                ? el.possible_score
                                                : '';

                                            return (
                                              <tr key={taskIndex}>
                                                <th
                                                  scope="row"
                                                  className="az-inspection-black pl-15 insp_inner_p"
                                                >
                                                  {el.task_name ? (
                                                    <span
                                                      dangerouslySetInnerHTML={{
                                                        __html:
                                                          this.modifyTaskName(
                                                            el.task_name
                                                          ),
                                                      }}
                                                    />
                                                  ) : (
                                                    ""
                                                  )}
                                                </th>
                                                <td>
                                                  {el.task_status == 1 ? (
                                                    <label>
                                                      <img
                                                        src={greentick}
                                                        alt=""
                                                      />
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                <td>
                                                  {el.task_status == 2 ? (
                                                    <label>
                                                      <img src={redtick} alt="" />
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                <td>
                                                  {el.notes_mros_count?.notes > 0 ? (
                                                    <label
                                                      className="log hand-cursor text-primary"
                                                      onClick={() =>
                                                        this.openNotesModal(el)
                                                      }
                                                    >
                                                      <img
                                                        src={bluetick}
                                                        alt=""
                                                        className="m-0"
                                                      />
                                                      {el.notes_mros_count.notes > 1
                                                        ? ` (${el.notes_mros_count.notes})`
                                                        : ""}
                                                    </label>
                                                  ) : (
                                                    ""
                                                  )}
                                                </td>
                                                {this.state.is_enable_weight == 1 ?
                                                  (<td className="az-inspection-black pl-15 insp_inner_p hover-td-bg-none">
                                                    <div className="score-info">
                                                      <span>
                                                        <b>{actualScore}/{possibleScore}</b>
                                                      </span>
                                                    </div>
                                                  
                                                </td>
                                                ) : ''}
                                                <td>
                                                  <code>
                                                    {el.notes_mros_count?.mros > 0 ? (
                                                      <label
                                                        className="log hand-cursor text-primary"
                                                        onClick={() =>
                                                          this.openMrosModal(el)
                                                        }
                                                      >
                                                        <img
                                                          src={redtick}
                                                          alt=""
                                                        />
                                                        {el.notes_mros_count.mros > 1
                                                          ? ` (${el.notes_mros_count.mros})`
                                                          : ""}
                                                      </label>
                                                    ) : (
                                                      ""
                                                    )}
                                                  </code>
                                                </td>
                                              </tr>
                                            );
                                          })
                                        : ""}
                                    </>
                                  )}
                                </React.Fragment>
                              ))
                            : " "}
                        </tbody>
                      </Table>
                    </div>
                    {/* table-responsive */}
                  </div>
                </div>
              </div>
            </div>
            {/* for mro */}
            <div className="row row-xs">
              <div className="col-md-12 mg-t-0 mg-b-10 pd-t-10 pd-b-10">
                <div className="brandSection">
                  <div className="mg-t-0 brandList dashboardRightcard pt-2 pb-2 scroll_mro">
                    <div className="table-responsive tableFormatesimple">
                      <Table striped className="mg-b-0">
                        <thead>
                          <tr>
                            <th className="border-right-0 wid_50 ">
                              MRO WRITTEN
                            </th>
                            <th className="border-left-0 ">VIEW DETAILS</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.category
                            ? this.state.category.map((elm, j) =>
                                elm.tasks
                                  ? elm.tasks.map((el, i) =>
                                      Array.isArray(el.notesMrosItems)
                                        ? el.notesMrosItems
                                            .filter((item) => item.is_mro === 1)
                                            .map((item, k) => (
                                              <tr key={i + "_" + k}>
                                                <th
                                                  scope="row"
                                                  className="az-inspection-black border-right-0 insp_inner_p"
                                                >
                                                  &nbsp;&nbsp;&nbsp;
                                                  <span
                                                    dangerouslySetInnerHTML={{
                                                      __html: this.modifyTaskName(
                                                        item.title
                                                      ),
                                                    }}
                                                  />
                                                  <Link
                                                    to={"/mros/update/" + item.slug}
                                                    className="az-inspection-brown"
                                                  >
                                                    <code>
                                                      ({item.mro_number || ""}
                                                      -MRO
                                                    </code>
                                                    )
                                                  </Link>
                                                </th>
                                                <td className="border-left-0 pl-5">
                                                  <i className="mdi mdi-eye-outline text-primary"></i>
                                                  <Link
                                                    to={"/mros/update/" + item.slug}
                                                    className=""
                                                  >
                                                    <img src={brownArrow} alt="" />
                                                  </Link>
                                                </td>
                                              </tr>
                                            ))
                                        : ""
                                    )
                                  : ""
                              )
                            : ""}
                          {this.state.isAvail === 0 ? (
                            <tr>
                              <th colSpan={3} className="p-0 border-bottom-0">
                                <caption>No Record Found</caption>
                              </th>
                            </tr>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </Table>
                    </div>
                    {/* bd */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {this.state.showModalImage && (
          <DeleteImageModal
            showModalImage={this.state.showModalImage}
            slug={this.state.imageSlug}
            onRemove={() => this.deleteImage(this.state.imageSlug)}
            onClose={this.onCloseImagePop}
          />
        )}
        <Modal show={this.state.showBasicModal} centered>
          <Modal.Body
            className={`width_402 p-4 border_radius_14 ${additionalClass}`}
          >
            <span className="welcomeClose" onClick={() => this.closeModal()}>
              {global.closee}
            </span>

            <h3 className="text-center">
              {this.state.modalType === "mro" ? "MROs" : "Notes"}
            </h3>
            {this.state.modalTaskName && (
              <p className="text-center font-weight-bold model_first_p editor_text_box">
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.modifyTaskName(this.state.modalTaskName),
                  }}
                />
              </p>
            )}

            {this.state.modalItems.length === 0 ? (
              <p className="text-center">No record found.</p>
            ) : (
              this.state.modalItems.map((item, itemIdx) => (
                <div
                  key={item.slug || itemIdx}
                  className="mg-b-15 pd-b-15"
                  style={{ borderBottom: "1px solid #eee" }}
                >
                  <p className="text-left ">
                    {item.is_mro === 1 ? "MRO" : "Note"}
                    {item.mro_number ? ` (${item.mro_number})` : ""}
                  </p>
                  <p
                    className="text-left"
                    style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.modifyTaskName(item.note),
                      }}
                    />
                  </p>
                  <div className="d-flex justify-content-start row position-relative mt-3">
                    {item.images.map((record, i) => (
                      <div key={"Data" + itemIdx + "_" + i} className="position-relative">
                        <div
                          className="pop-up-image-megnify"
                          onClick={() => this.imageRedirect(record.uri)}
                        >
                          <ReactImageMagnify
                            {...{
                              smallImage: {
                                alt: "",
                                isFluidWidth: true,
                                src: record.uri,
                              },
                              largeImage: {
                                src: record.uri,
                                width: 200,
                                height: 200,
                              },
                              enlargedImagePosition: "beside",
                              enlargedImageContainerDimensions: {
                                width: "300%",
                                height: "300%",
                              },
                              className: "custom-image-magnify",
                            }}
                          />
                        </div>
                        {global.userPermissions.checkPermission(
                          "mros-delete"
                        ) && (
                          <button
                            type="button"
                            className="btN btn_remove position-absolute"
                            onClick={() => this.toggleModal(record.slug)}
                          >
                            <span className="fa fa-times"></span>
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                  {item.is_mro === 1 && (
                    <div className="d-flex justify-content-end row mt-3 mr-3">
                      <Link
                        to={"/mros/update/" + item.slug}
                        className="detlet-text"
                        style={{
                          color: "#272E79",
                          fontFamily: "Oswald-Regular",
                          fontSize: "14px",
                          textTransform: "uppercase",
                        }}
                      >
                        Detail
                      </Link>
                    </div>
                  )}
                </div>
              ))
            )}

            <div className="d-flex cnt_center row mt-3">
              <button
                type="button"
                className="m-0 btn btn-outline-light btn-block"
                onClick={() => this.closeModal()}
              >
                Close
              </button>
            </div>
          </Modal.Body>
        </Modal>
        <Modal show={this.state.deleteInspModal} centered>
          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="text-center">
              {/* <img src={modaldeleteicon} alt="modal-delete-icon" /> */}
              <h3>Delete Inspection?</h3>
              <p className="pd-l-50 pd-r-50 pd-b-20 model_first_p">
                Do you really want to delete this Inspection? This process
                cannot be undone.
              </p>
              <div className="d-flex cnt_center mt-3 row">
                <button
                  type="button"
                  className="m-0 btn btn-outline-light btn-block"
                  onClick={() => this.closedeleteInspModal()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="m-0 btn btn btn-danger btn-block"
                  onClick={() => this.deleteInsp(this.state.slug)}
                  disabled={this.state.isDelete ? true : false}
                >
                  {this.state.isDelete ? global.loader : "Delete"}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default InspectionForm;
